import { useParams, Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useShortsFeed } from "../hooks/useShortsFeed";
import { ShortsStage } from "../components/shorts/ShortsStage";
import { ShortsOverlay } from "../components/shorts/ShortsOverlay";

const FullScreen = ({ children, testid }) => (
  <div className="fixed inset-0 bg-black flex flex-col items-center justify-center text-white gap-4 px-6 text-center" data-testid={testid}>{children}</div>
);

/** Vertical full-screen Shorts player (TikTok/Reels style). Route: /shorts/:channelId? */
export default function ShortsPlayer() {
  const { channelId } = useParams();
  const isFeedMode = !channelId;
  const feed = useShortsFeed(channelId);
  const { loading, channel, videos, current, muted, next, gestures } = feed;

  if (loading) {
    return <FullScreen testid="shorts-loading"><Loader2 className="w-8 h-8 animate-spin text-[color:var(--accent)]" /></FullScreen>;
  }
  if (!channel) {
    return (
      <FullScreen>
        <div className="text-2xl font-display">Chaîne introuvable</div>
        <Link to="/channels" className="text-[color:var(--accent)] underline text-sm">Retour aux chaînes</Link>
      </FullScreen>
    );
  }
  if (videos.length === 0) {
    return (
      <FullScreen>
        <div className="text-2xl font-display">{channel.name}</div>
        <div className="text-[color:var(--text-muted)]">{"Aucun short pour l'instant."}</div>
        <Link to={`/channel/${channel.slug}`} className="mt-4 px-5 py-2 rounded-full border border-[color:var(--border)] hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] text-xs uppercase tracking-widest transition">
          Voir la chaîne classique
        </Link>
      </FullScreen>
    );
  }

  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center overflow-hidden select-none" {...gestures} data-testid="shorts-player">
      <div className="relative bg-black" style={{ height: "min(100vh, 100dvh)", width: "min(56.25vh, 56.25dvh, 100vw)", maxWidth: "100vw" }} data-testid="shorts-stage">
        <ShortsStage current={current} muted={muted} onEnded={next} />
        <ShortsOverlay feed={feed} isFeedMode={isFeedMode} />
      </div>
    </div>
  );
}
